// Real photo/role for the one team member we can currently confirm (see
// Impressum: "Geschäftsführer: Nils Jäkel") — first name only on the
// tiles. `photo` is the default portrait, `hoverPhoto` swaps in on hover
// (a LARP-costume shot). Maria/Benjamin/Jonas/Tobias use generic class-icon
// art instead of real photos — real photos still pending, but their roles
// are now confirmed.
export const TEAM = {
  de: [
    {
      name: "Nils",
      role: "Geschäftsführer",
      roleBody:
        "Vertritt die gUG nach außen, kümmert sich um Verträge, Buchhaltung, Anmeldungen und die Website — also um alles, was passieren muss, damit ein Event überhaupt stattfinden darf.",
      photo: "/assets/brand/nja_01.png",
      hoverPhoto: "/assets/brand/nja_02.png",
    },
    {
      name: "Maria",
      role: "Gewandung & Requisiten",
      roleBody:
        "Baut und pflegt unseren Fundus: Leihgewandung für Einsteiger:innen, NSC-Kostüme und die kleinen Requisiten, an denen eine Szene hängt.",
      photo: "/assets/brand/Female Orc_red circle.png",
      hoverPhoto: null,
    },
    {
      name: "Benjamin",
      role: "Spielwelt & Plot",
      roleBody:
        "Entwickelt die Realms of Lorell weiter, schreibt Plots und sorgt dafür, dass jede Gruppe auf einem Event etwas zu tun bekommt — auch die, die keinen Kampf suchen.",
      photo: "/assets/brand/Male Elf_red circle.png",
      hoverPhoto: null,
    },
    {
      name: "Jonas",
      role: "Bau & Requisiten",
      roleBody:
        "Zuständig für Kulissen, Lageraufbau und Technik. Baut aus Holz, Farbe und Improvisation die Orte, in denen gespielt wird — und baut sie sonntags wieder ab.",
      photo: "/assets/brand/Male Elf_red circle.png",
      hoverPhoto: null,
    },
    {
      name: "Tobias",
      role: "Jugendarbeit",
      roleBody:
        "Plant unsere Jugend-Events, hält Kontakt zu Jugendhäusern und Schulen und achtet darauf, dass Betreuungsschlüssel und Schutzkonzept im Alltag auch wirklich gelebt werden.",
      photo: "/assets/brand/Male Elf_red circle.png",
      hoverPhoto: null,
    },
  ],
  en: [
    {
      name: "Nils",
      role: "Managing Director",
      roleBody:
        "Represents the gUG, and handles contracts, bookkeeping, registrations and the website — everything that has to happen before an event is allowed to take place at all.",
      photo: "/assets/brand/nja_01.png",
      hoverPhoto: "/assets/brand/nja_02.png",
    },
    {
      name: "Maria",
      role: "Costumes & Props",
      roleBody:
        "Builds and maintains our stock: loan costume for beginners, NPC outfits and the small props a scene hangs on.",
      photo: "/assets/brand/Female Orc_red circle.png",
      hoverPhoto: null,
    },
    {
      name: "Benjamin",
      role: "Game World & Plot",
      roleBody:
        "Develops the Realms of Lorell, writes plot and makes sure every group at an event has something to do — including the ones not looking for a fight.",
      photo: "/assets/brand/Male Elf_red circle.png",
      hoverPhoto: null,
    },
    {
      name: "Jonas",
      role: "Construction & Props",
      roleBody:
        "Responsible for set pieces, camp build-up and technical kit. Turns wood, paint and improvisation into the places we play in — and takes them down again on Sunday.",
      photo: "/assets/brand/Male Elf_red circle.png",
      hoverPhoto: null,
    },
    {
      name: "Tobias",
      role: "Youth Work",
      roleBody:
        "Plans our youth events, keeps in touch with youth centres and schools, and makes sure the staffing ratio and safeguarding concept are lived in practice.",
      photo: "/assets/brand/Male Elf_red circle.png",
      hoverPhoto: null,
    },
  ],
};
